import { Component } from 'react';
import { tags } from './keys';
import TopPages from '../TopPages';
import EntityTopAuthors from '../EntityTopAuthors';
import { withTranslation } from 'react-i18next';

class EntityContentContainer extends Component {
    constructor() {
        super();
        this.onClick = this.onClick.bind(this);
        this.addActive = this.addActive.bind(this);
        this.showElement = this.showElement.bind(this);

        this.state = {
            types: ['pages'],
            alreadeOpenedAuthors: false,
        };
    }

    showElement(id) {
        return !this.state.types.length || this.state.types.includes(id);
    }

    onClick(id) {
        if (id === 'authors') {
            return this.setState({
                types: [id],
                alreadeOpenedAuthors: true,
            });
        }
        return this.setState({
            types: [id],
        });
    }

    addActive(id) {
        return this.state.types.includes(id);
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <div className="tags-container">
                    {tags(t).map((tag) => (
                        <span
                            className={`tab-item ${this.addActive(tag.id) && 'active-tag'}`}
                            key={tag.id}
                            onClick={() => this.onClick(tag.id)}
                        >
                            {tag.label}
                        </span>
                    ))}
                </div>
                <div
                    className="row card-row"
                    id="entity_pages"
                    style={{
                        display: this.showElement('pages') ? 'flex' : 'none',
                    }}
                >
                    <div className="col-12">
                        <div className="card table-main rounded-main overflow-hidden">
                            <TopPages
                                default_image={this.props.default_image}
                                parent_id="entities_data"
                                content_id="entity_pages"
                            />
                        </div>
                    </div>
                </div>
                {this.state.alreadeOpenedAuthors && (
                    <div
                        className="row card-row"
                        id="entity_pages"
                        style={{
                            display: this.showElement('authors') ? 'flex' : 'none',
                        }}
                    >
                        <div className="col-12">
                            <div className="card table-main rounded-main overflow-hidden">
                                <EntityTopAuthors />
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }
}
export default withTranslation()(EntityContentContainer);
